import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import t from 'tcomb-form';
import { doSaveSharedStory } from '../../actions';
import CityAutosuggestFactory from '../../components/CityAutosuggest';
import { WebsiteRefinement, WebsiteTransformer } from '../../utils/tcomb-utils';

import { objectToFormData } from '../../utils/index';

const SharedStorySchema = t.struct({
  user_background: t.String,
  influences: t.String,
  experiences: t.String,
  imagine: t.String
});

const formOptions = {
  auto: 'none',
  fields: {
    user_background: {
      type: 'textarea',
      label: <span>Tell us about your background and what you do with your time. <span className='sharedStory-required'>*</span></span>,
      attrs: {
        maxLength: 200,
      }
    },
    influences: {
      error: 'This field is required.',
      type: 'textarea',
      label: <span>Who is the greatest female influence in your life? <span className='sharedStory-required'>*</span></span>,
      attrs: {
        maxLength: 200,
      }
    },
    experiences: {
      error: 'This field is required.',
      type: 'textarea',
      label: <span>Please share with us something that you want other women around the world to hear. This can be a significant experience  you've had, a challenge you've faced, advice, or even a powerful quote. <span className='sharedStory-required'>*</span></span>,
      attrs: {
        maxLength: 200
      }
    },
    imagine: {
      error: 'This field is required.',
      type: 'textarea',
      label: <span>What do you imagine for women and girls around the world? <span className='sharedStory-required'>*</span></span>,
      attrs: {
        maxLength: 200
      }
    }
  }
};

class SharedStoryStep2 extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    formOptions: formOptions,
    formValues: {}
  }

  onFormChange = formValues => {
    this.setState({ formValues });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const value = this.refs.sharedStoryForm.getValue();
    if(!value) {
      return;
    } else {

      let content = objectToFormData(value)

      this.props.doSaveSharedStory(content);
      this.props.goToStep3();

      if (typeof(window) !== "undefined") {
        window.scrollTo(0,0)
      }
      this.resetForm();
    }
  }

  resetForm = (e) => {
    this.setState({ formValues: {
      user_background: '',
      influences: '',
      experiences: '',
      imagine: '',
      social_share: '',
      www_photo: ''
    }})
  }

  render() {

    return(
    <div className="sharedStory-step2Wrapper">
      <div className="sharedStory-progressbar">
        <img src="/images/shared_stories/apply_step01.png" />
      </div>
      <div className="sharedStoryWrapper sharedStoryWrapper-formWrapper">
        <form className="shared-story-form" onSubmit={(e)=>{ e.prevenDetault(); }}>
        <t.form.Form ref="sharedStoryForm" value={this.state.formValues} onChange={this.onFormChange} type={SharedStorySchema} options={this.state.formOptions} />
        <button onClick={this.handleSubmit} className="my-account-submit submitButton button-primary" type="submit">Submit</button>&nbsp;
        <button onClick={this.reset} className="submitButton " type="reset">Reset</button>&nbsp;
        </form>
      </div>
    </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    doSaveSharedStory
  }
)(SharedStoryStep2);



// WEBPACK FOOTER //
// ./src/components/sharedStory/SharedStoryStep2.jsx